export default class showcaseColor {

    static init() {

		$('.section--showcase-color .list-color ul li[data-color]').on("click", function () {
			$(".list-color li[data-color], .list-img img[data-img]").removeClass(['active', 'show']);
			$(this).addClass('active');
			$(".list-img").find('[data-img="' + $(this).attr("data-color") + '"]').addClass('show');
		});

    }

}
